import { Component, Inject } from '@angular/core';
import { INativeStorageService, NATIVE_STORAGE_SERVICE } from '@boxx/core';
import {
  GETNET_BRAND,
  LIGHT_BRAND,
  MND_BRAND,
  TELCEL_BRAND,
  TELMEX_BRAND,
  TOTALPLAY_BRAND,
} from '../../mocks/brand-data';
import { BOXX_BRAND } from '../../mocks/brand-data-prod';
import {
  BRANDING_LS_KEY,
  DynamicBrandingService,
  IBrandigApiProps,
} from '../../services/dynamic-branding-service';

@Component({
  selector: 'boxx-brand-dropdown',
  templateUrl: './brand-dropdown.component.html',
  styleUrls: ['./brand-dropdown.component.scss'],
})
export class BrandingDropdown {
  canShowBrandingPicker = false;
  selectedBrand = 'boxx';
  readonly developerEmails = ['avb@virket.com']; //, 'jegm@virket.com'

  constructor(
    private dBrandingService: DynamicBrandingService,
    @Inject(NATIVE_STORAGE_SERVICE) private storageService: INativeStorageService
  ) {
    this.storageService.getItem(BRANDING_LS_KEY).then(rawBranding => {
      if (rawBranding) {
        const parsedBranding = JSON.parse(rawBranding) as IBrandigApiProps;
        this.selectedBrand = parsedBranding.name;
      }
    });

    this.dBrandingService.userEmail$.subscribe(email => {
      this.canShowBrandingPicker = this.developerEmails.includes(email);
    });
  }

  pickBrand(brand: string) {
    switch (brand as 'boxx' | 'getnet' | 'telmex' | 'totalplay' | 'telcel' | 'mnd' | 'light') {
      case 'boxx':
        this.dBrandingService.setTheme(BOXX_BRAND);
        break;
      case 'getnet':
        this.dBrandingService.setTheme(GETNET_BRAND);
        break;
      case 'telmex':
        this.dBrandingService.setTheme(TELMEX_BRAND);
        break;
      case 'totalplay':
        this.dBrandingService.setTheme(TOTALPLAY_BRAND);
        break;
      case 'telcel':
        this.dBrandingService.setTheme(TELCEL_BRAND);
        break;
      case 'mnd':
        this.dBrandingService.setTheme(MND_BRAND);
        break;
      case 'light':
        this.dBrandingService.setTheme(LIGHT_BRAND);
        break;
      default:
        this.dBrandingService.resetTheme();
    }
  }
}
